import { render, staticRenderFns } from "./onlineVideo.vue?vue&type=template&id=25f58c58&scoped=true"
import script from "./onlineVideo.vue?vue&type=script&lang=js"
export * from "./onlineVideo.vue?vue&type=script&lang=js"
import style0 from "./onlineVideo.vue?vue&type=style&index=0&id=25f58c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f58c58",
  null
  
)

export default component.exports